import {
    type GetUnreadCountResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetUnreadCount = async (): Promise<GetUnreadCountResponseType> => {
    return await axios(`${SERVER_ADDRESS}/notification/getUnreadCount`, {
        headers: getHeaders(true),
        method: "GET"
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};

export default GetUnreadCount;
